import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { PoModalModule, PoPageModule, PoWidgetModule, PoFieldModule, PoButtonModule, PoContainerModule, PoLoadingModule, PoTooltipModule, PoSelectOption } from '@po-ui/ng-components';
import { InventoryService } from '../../../shared/service/inventory.service';
import { TokenService } from '../../../shared/service/token.service';
import { InventoryModel } from '../../../models/inventory.model';
import { InventoryHeaderCardComponent } from './inventory-header-card/inventory-header-card.component';
import { INVENTORY_STATUS } from '../../../constants';
import { DateRangeComponent } from '../../../shared/components/date-range/date-range.component';

@Component({
  selector: 'app-inventory-header',
  imports: [FormsModule,
    PoModalModule,
    PoPageModule,
    PoWidgetModule,
    PoFieldModule,
    PoButtonModule,
    PoContainerModule,
    CommonModule,
    PoLoadingModule,
    PoTooltipModule,
    ReactiveFormsModule,
    FormsModule,
    InventoryHeaderCardComponent,
    DateRangeComponent],
  templateUrl: './inventory-header.component.html',
  styleUrl: './inventory-header.component.css'
})
export class InventoryHeaderComponent implements OnInit, AfterViewInit {
  @Output() isLoading = new EventEmitter<boolean>();
  @Output() onOpenInventoryCount = new EventEmitter<InventoryModel>();
  filterForm!: FormGroup;
  newInventoryCountForm!: FormGroup;
  inventoryItems: InventoryModel[] = [];
  statusFilter = '';
  seeFilter: boolean = false;
  fadeInAnimation = false;
  funnelIcon = 'an an-funnel-simple';
  arrowDown = 'an an-arrow-down';
  properties: Array<string> = [];
  readonly statusItens = INVENTORY_STATUS;

  constructor(
    private inventoryService: InventoryService,
    private tokenService: TokenService,
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder) {

  }
  ngOnInit(): void {
    this.initFilterForm();
  }

  ngAfterViewInit(): void {
    this.getInventoryItems();
    this.cdRef.detectChanges();
  }

  initFilterForm() {
    this.filterForm = this.fb.group({
      inventoryCodeFilter: [null],
      startDate: [new Date()],
      endDate: [new Date],
      inventoryStatusFilter: ['1']
    });
  }

  getInventoryItems() {
    this.loading(true);
    const loggedBranchCode = this.tokenService.getBranch();
    const inventoryCodeParam = this.filterForm.get('inventoryCodeFilter')?.value;
    const startDateParam = this.filterForm.get('startDate')?.value ? new Date(this.filterForm.get('startDate')?.value) : null;
    const endDateParam = this.filterForm.get('endDate')?.value ? new Date(this.filterForm.get('endDate')?.value) : null;
    const inventoryStatusFilterParam = this.filterForm.get('inventoryStatusFilter')?.value;

    this.inventoryService.getInventoryHeaderList(Number(loggedBranchCode), Number(inventoryStatusFilterParam), startDateParam, endDateParam, isNaN(inventoryCodeParam) ? null : inventoryCodeParam).subscribe({
      next: (data) => {
        this.loading(false);
        this.inventoryItems = data.items;
        this.executeFadeInAnimation();
      }, error: () => {
        this.loading(false);
        this.inventoryItems = [];
      }
    });
  }

  loading(value: boolean) {
    this.isLoading.emit(value);
  }

  onSeeFilter() {
    this.seeFilter = !this.seeFilter;
  }

  executeFadeInAnimation() {
    this.fadeInAnimation = false;
    setTimeout(() => {
      this.fadeInAnimation = true;
    }, 10);
  }

  recoverStatusSelected(event: any) {
    this.statusFilter = event;
  }

  invalidDateValidator(control: AbstractControl): { [key: string]: any } | null {
    if (!control.value) {
      return null;
    }

    const date = new Date(control.value);
    if (isNaN(date.getTime())) {
      return { invalidDate: 'Data inválida' };
    }

    return null;
  }

  onFilter() {
    this.filterForm.markAllAsTouched();
    this.filterForm.updateValueAndValidity();

    if (this.filterForm.invalid) {
      this.filterForm.markAllAsTouched();
      return;
    }

    this.getInventoryItems();
  }

  cleanFilter() {
    this.filterForm.patchValue({
      startDate: new Date(),
      endDate: new Date(),
      inventoryCodeFilter: '',
    });

    this.getInventoryItems();
  }

  onInventoryHeaderSelected(item: InventoryModel) {
    this.onOpenInventoryCount.emit(item);
  }
}
